import noop from '@anm/helpers/noop';
import { PropsWithChildren } from 'react';

import BreadcrumbIconButton from '../BreadcrumbIconButton';

import BreadcrumbDropdownContent, { BreadcrumbDropdown, BreadcrumbDropdownItem } from './Wrapper';

type DropDownListProps<T> = {
  data: T[];
  onClick?: (item: T) => void;
};

type DropDownListItemProps = {
  id: number | string;
  name: string;
};

const DropDownList = <T extends DropDownListItemProps>({
  data,
  onClick = noop
}: PropsWithChildren<DropDownListProps<T>>) => (
  <BreadcrumbDropdown
    direction="to-bottom-left"
    renderContent={() => (
      <BreadcrumbDropdownContent>
        {data.map(item => (
          <BreadcrumbDropdownItem key={item.id} onClick={() => onClick(item)}>
            <span>{item.name}</span>
          </BreadcrumbDropdownItem>
        ))}
      </BreadcrumbDropdownContent>
    )}
  >
    <BreadcrumbIconButton />
  </BreadcrumbDropdown>
);

export default DropDownList;
